import { MoonLoader } from 'react-spinners';

const Loader = ({ size = 70 }: { size?: number }) => (
  <div className="loader">
    <MoonLoader color="#000000" size={size} />
  </div>
)

export default Loader;